import { Icon } from '@/new/components/icon';
import { cn } from '@/new/lib/utils';

interface DocumentTabsProps {
  tabs: Array<{ id: string; label: string }>;
  selectedId: string | null;
  onSelect: (id: string) => void;
  isInfoPanelCollapsed?: boolean;
  onToggleInfoPanel?: () => void;
}

export function DocumentTabs({
  tabs,
  selectedId,
  onSelect,
  isInfoPanelCollapsed,
  onToggleInfoPanel,
}: DocumentTabsProps) {
  return (
    <div className="mx-4 flex items-end gap-1 text-xs">
      <div className="flex min-w-0 flex-1 gap-1 overflow-x-scroll [scrollbar-width:none]">
        {tabs.map((tab, i) => (
          <button
            key={tab.id}
            className={cn(
              'flex min-w-0 items-center gap-1.5 rounded-t-lg border p-1 px-2.25 pt-1.5 text-xs font-medium duration-150',
              tab.id === selectedId
                ? 'z-30 shrink-0 border-b-white bg-white text-gray-600'
                : 'z-30 min-w-9 border-b-gray-200 bg-gray-50 text-gray-500 hover:bg-white',
            )}
            onClick={() => onSelect(tab.id)}
          >
            {tabs.length > 1 && (
              <span
                className={cn(
                  'border-sky-300 bg-sky-100 text-sky-500',
                  'inline-flex size-3.75 shrink-0 items-center justify-center rounded-full border text-[8px]',
                )}
              >
                <span className="mt-px">{i + 1}</span>
              </span>
            )}
            <span className={cn(tab.id === selectedId ? 'text-nowrap' : 'truncate')}>{tab.label}</span>
          </button>
        ))}
      </div>

      {onToggleInfoPanel && typeof isInfoPanelCollapsed === 'boolean' && (
        <button
          type="button"
          className="z-30 flex shrink-0 items-center gap-1 rounded-t-lg border border-b-white bg-white px-2.25 pt-1.5 pb-1 text-xs font-medium text-gray-500 duration-150 hover:text-gray-900"
          aria-expanded={!isInfoPanelCollapsed}
          onClick={onToggleInfoPanel}
        >
          <Icon className={isInfoPanelCollapsed ? 'lucide--chevron-up' : 'lucide--chevron-down'} />
          <span>{isInfoPanelCollapsed ? 'Expand' : 'Hide'}</span>
        </button>
      )}
    </div>
  );
}
